import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import StickyCallBar from "@/components/site/StickyCallBar";
import QuoteForm from "@/components/site/QuoteForm";

const SITE_URL = "https://honeybeeroofers.com";

export default function RecentProjects() {
  const [modal, setModal] = useState(false);

  useEffect(() => {
    document.title = "Recent Roofing Projects | Snohomish, King & Skagit County | Honey Bee";
    window.scrollTo(0, 0);
    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", "See recent roof replacement, repair, and exterior projects completed by Honey Bee Roofing & Exteriors across Snohomish, King & Skagit County, WA.");
    setMeta("name", "robots", "index, follow");
    let c = document.head.querySelector('link[rel="canonical"]');
    if (!c) { c = document.createElement("link"); c.setAttribute("rel", "canonical"); document.head.appendChild(c); }
    c.setAttribute("href", `${SITE_URL}/recent-projects`);

    // Initialize the RealWorkLabs widget once the loader is ready and the target div exists.
    const init = () => {
      try {
        if (window.rwlPlugin && typeof window.rwlPlugin.init === "function") {
          window.rwlPlugin.init("https://app.realworklabs.com", "zkjtV-AXoisfymKI");
        }
      } catch (e) { /* no-op */ }
    };
    if (window.rwlPlugin) init();
    else window.addEventListener("rwlPluginReady", init, false);
    return () => window.removeEventListener("rwlPluginReady", init, false);
  }, []);

  return (
    <div className="bg-obsidian min-h-screen">
      <Header onQuote={() => setModal(true)} />

      <section className="pt-36 pb-12 honeycomb-bg">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <p className="text-xs uppercase tracking-[0.2em] text-honey font-bold mb-3">Our Work</p>
          <h1 className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
            Recent Projects
          </h1>
          <p className="text-lg text-zinc-400 mt-5 max-w-2xl">
            A look at recent roof replacements, repairs, and exterior work we've completed for homeowners across
            Snohomish, King &amp; Skagit County.
          </p>
        </div>
      </section>

      <section className="pb-24 bg-obsidian">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          {/* RealWorkLabs projects widget renders here */}
          <div id="rwl-output"></div>
        </div>
      </section>

      <Footer />
      <StickyCallBar onQuote={() => setModal(true)} />

      {modal && (
        <div data-testid="quote-modal" onClick={() => setModal(false)}
          data-lenis-prevent className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm overflow-y-auto">
          <motion.div initial={{ scale: 0.95, y: 20 }} animate={{ scale: 1, y: 0 }} onClick={(e) => e.stopPropagation()}
            className="relative bg-carbon border border-white/10 rounded-md p-6 sm:p-8 w-full max-w-md my-8">
            <button onClick={() => setModal(false)} data-testid="quote-modal-close" className="absolute top-4 right-4 text-zinc-400 hover:text-white">
              <X className="w-5 h-5" />
            </button>
            <h2 className="text-2xl font-display font-bold text-white mb-1">Free Roof Evaluation</h2>
            <p className="text-sm text-zinc-400 mb-5">Fixed, no-hassle pricing in 30 seconds.</p>
            <QuoteForm onSuccess={() => {}} />
          </motion.div>
        </div>
      )}
    </div>
  );
}
